import styled from "styled-components";
import { Skeleton } from "@mui/material";

export const SkeletonStyled = styled(Skeleton)`
padding: 20px 0;

`;